import React, { useState, useEffect } from 'react'; // Added useState, useEffect
import Icon from '../../../components/AppIcon';

const Footer = () => {
  const currentYear = new Date()?.getFullYear();
  const [showBackToTopButton, setShowBackToTopButton] = useState(false); // State for button visibility

  // Scroll event listener
  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset > 300) { // Show button after scrolling 300px
        setShowBackToTopButton(true);
      } else {
        setShowBackToTopButton(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleBackToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handlePhoneClick = () => {
    window.location.href = 'tel:+6282226648077';
  };

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/6282226648077?text=Halo%20AC%20Service%20Pro!%20Saya%20ingin%20konsultasi%20tentang%20layanan%20AC.', '_blank');
  };

  const handleEmailClick = () => {
    window.location.href = 'mailto:idaylummm@gmail.com';
  };

  const services = [
    "Perbaikan AC",
    "Cuci AC",
    "Bongkar Pasang AC",
    "Maintenance AC",
    "Instalasi AC Baru",
    "Service Berkala"
  ];

  const areas = [
    "Jakarta Pusat",
    "Jakarta Selatan", 
    "Jakarta Timur",
    "Jakarta Barat",
    "Jakarta Utara",
    "Bogor & Depok",
    "Tangerang",
    "Bekasi"
  ];

  const quickLinks = [
    { name: "Tentang Kami", href: "#tentang" },
    { name: "Layanan", href: "#layanan" },
    { name: "Testimoni", href: "#testimoni" },
    { name: "Kontak", href: "#kontak" },
    { name: "FAQ", href: "#faq" },
    { name: "Emergency 24/7", href: "#emergency" }
  ];

  return (
    <footer className="bg-foreground text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-2 mb-6">
              <img src="/assets/images/logo.png" alt="Dewi Jaya Service Logo" className="w-12 h-12 object-contain" />
              <div className="flex flex-col">
                <span className="font-heading font-bold text-xl text-white">AssA AC</span>
                <span className="font-heading font-semibold text-sm text-secondary -mt-1">Service</span>
              </div>
            </div>
            
            <p className="text-gray-300 mb-6 leading-relaxed">
              Penyedia layanan AC terpercaya, dengan teknisi bersertifikat, 
              harga transparan, dan garansi kepuasan 100%.
            </p>

            {/* Contact Info */}
            <div className="space-y-3">
              <button
                onClick={handlePhoneClick}
                className="flex items-center text-gray-300 hover:text-accent transition-colors"
              >
                <Icon name="Phone" size={16} className="mr-3" />
                <span>0822-2664-8077</span>
              </button>
              <button
                onClick={handleEmailClick}
                className="flex items-center text-gray-300 hover:text-accent transition-colors"
              >
                <Icon name="Mail" size={16} className="mr-3" />
                <span>idaylummm@gmail.com</span>
              </button>
              <div className="flex items-start text-gray-300">
                <Icon name="MapPin" size={16} className="mr-3 mt-1 flex-shrink-0" />
                <span>NO.71, Jl. Raya Bulak Sentul RT004/029, RT.003/RW.017, Harapan Jaya, 17124</span>
              </div>
            </div>

            {/* Social Media */}
            <div className="flex space-x-4 mt-6">
              <a href="#" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-700 rounded-lg flex items-center justify-center hover:bg-primary transition-colors">
                <Icon name="Facebook" size={20} />
              </a>
              <a href="#" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-700 rounded-lg flex items-center justify-center hover:bg-secondary transition-colors">
                <Icon name="Instagram" size={20} />
              </a>
              <button 
                onClick={handleWhatsAppClick}
                className="w-10 h-10 bg-gray-700 rounded-lg flex items-center justify-center hover:bg-accent transition-colors"
              >
                <Icon name="MessageCircle" size={20} />
              </button>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-heading font-bold text-lg text-white mb-6">Layanan Kami</h3>
            <ul className="space-y-3">
              {services?.map((service, index) => (
                <li key={index}>
                  <a 
                    href="#layanan" 
                    className="text-gray-300 hover:text-accent transition-colors flex items-center"
                  >
                    <Icon name="ChevronRight" size={14} className="mr-2" />
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h3 className="font-heading font-bold text-lg text-white mb-6">Area Layanan</h3>
            <ul className="space-y-3">
              {areas?.map((area, index) => (
                <li key={index}>
                  <div className="text-gray-300 flex items-center">
                    <Icon name="MapPin" size={14} className="mr-2 text-secondary" />
                    {area}
                  </div>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links & Emergency */}
          <div>
            <h3 className="font-heading font-bold text-lg text-white mb-6">Tautan Cepat</h3>
            <ul className="space-y-3 mb-8">
              {quickLinks?.map((link, index) => (
                <li key={index}>
                  <a 
                    href={link?.href} 
                    className="text-gray-300 hover:text-accent transition-colors flex items-center"
                  >
                    <Icon name="ChevronRight" size={14} className="mr-2" />
                    {link?.name}
                  </a>
                </li>
              ))}
            </ul>

            {/* Emergency Contact */}
            <div className="bg-destructive/10 border border-destructive/20 rounded-xl p-4">
              <h4 className="font-semibold text-white mb-2 flex items-center">
                <Icon name="AlertTriangle" size={16} className="mr-2 text-destructive" />
                Emergency 24/7
              </h4>
              <p className="text-gray-300 text-sm mb-3">
                AC rusak mendadak? Hubungi kami sekarang!
              </p>
              <button
                onClick={handlePhoneClick}
                className="w-full bg-destructive text-white py-2 rounded-lg font-semibold hover:bg-destructive/90 transition-colors text-sm"
              >
                Telepon Emergency
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Certifications & Trust Badges */}
      <div className="border-t border-gray-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="grid md:grid-cols-4 gap-6 text-center">
            <div className="flex items-center justify-center">
              <Icon name="Award" size={24} className="text-secondary mr-3" />
              <div className="text-left">
                <div className="font-semibold text-white text-sm">Sertifikat HVAC</div>
                <div className="text-gray-400 text-xs">Indonesia Certified</div>
              </div>
            </div>
            <div className="flex items-center justify-center">
              <Icon name="Shield" size={24} className="text-primary mr-3" />
              <div className="text-left">
                <div className="font-semibold text-white text-sm">Garansi Resmi</div>
                <div className="text-gray-400 text-xs">Hingga 1 Bulan</div>
              </div>
            </div>
            <div className="flex items-center justify-center">
              <Icon name="Users" size={24} className="text-accent mr-3" />
              <div className="text-left">
                <div className="font-semibold text-white text-sm">250+ Pelanggan</div>
                <div className="text-gray-400 text-xs">Puas & Terpercaya</div>
              </div>
            </div>
            <div className="flex items-center justify-center">
              <Icon name="Star" size={24} className="text-accent mr-3" />
              <div className="text-left">
                <div className="font-semibold text-white text-sm">Rating 4.9/5</div>
                <div className="text-gray-400 text-xs">Google Reviews</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Bottom Footer */}
      <div className="border-t border-gray-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm text-center md:text-left mb-4 md:mb-0">
              © {currentYear} AssA AC Service. All rights reserved. Developed by{""} <a href="https://traezkdev.vercel.app/" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">TraezkDev</a>
            </div>
            <div className="flex space-x-6 text-sm">
              <a href="/privacy-policy" className="text-gray-400 hover:text-accent transition-colors">
                Kebijakan Privasi
              </a>
              <a href="/terms-and-conditions" className="text-gray-400 hover:text-accent transition-colors">
                Syarat & Ketentuan
              </a>
              <a href="/sitemap" className="text-gray-400 hover:text-accent transition-colors">
                Sitemap
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* Floating Back to Top Button */}
      {showBackToTopButton && (
        <button
          onClick={handleBackToTop}
          className="fixed bottom-24 right-6 w-14 h-14 bg-primary rounded-full shadow-2xl flex items-center justify-center hover:bg-primary/90 transition-all duration-300 hover:scale-110 z-50"
        >
          <Icon name="ArrowUp" size={28} className="text-white" />
        </button>
      )}

      {/* Floating WhatsApp Button */}
      <button
        onClick={handleWhatsAppClick}
        className="fixed bottom-6 right-6 w-14 h-14 bg-secondary rounded-full shadow-2xl flex items-center justify-center hover:bg-secondary/90 transition-all duration-300 hover:scale-110 z-50"
      >
        <Icon name="MessageCircle" size={28} className="text-white" />
      </button>
    </footer>
  );
};

export default Footer;
